import * as React from "react";
import "../../style/fonts.css";
import "./progress.css";
import ProgressComp from "./progressComp";
import CtaButton from "../ctaButton/ctaButton";
import {
  setProgressUpdater,
  resetProgressVar,
} from "src/store/actions/regActions";
import {
  followUserAfter,
  redirectAfterLogin,
  resetRedirectVars,
  redirectToOverview,
} from "../../store/actions/supportActions";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import translate from "../../translations/i18n";
import firebase from "firebase";

export interface Props {
  setProgressUpdater(progess): void;
  resetProgressVar(): void;
  regError: any;
  progressUpdateCompleted: any;
  userStatusToFollow: any;
  userToFollowWithoutLogIn: any;
  userIdToFollowWithoutLogIn: any;
  followUserAfter(uid, user): void;
  ownAuth: any;
  redirectAfterLogin(): void;
  redirectUserAfterLogIn: any;
  redirectUserAfterFollow: any;
  resetRedirectVars(): void;
  redirectToOverviewComp: any;
  redirectToOverview(): void;
}

interface State {
  progress: string;
}

class ProgressScr extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { progress: "weekly" };
  }

  toggleSelect(period) {
    switch (period) {
      case "m":
        this.setState({ progress: "monthly" });
        break;
      case "w":
        this.setState({ progress: "weekly" });
        break;
      case "n":
        this.setState({ progress: "never" });
        break;
    }
  }

  selectProgressUpdate() {
    this.props.setProgressUpdater(this.state.progress);
  }

  componentDidUpdate(prevProps) {
    if (this.props.progressUpdateCompleted === true) {
      this.props.resetProgressVar();
      if (this.props.userStatusToFollow === true) {
        this.props.followUserAfter(
          this.props.ownAuth.uid,
          this.props.userToFollowWithoutLogIn
        );
        this.props.redirectAfterLogin();
      } else {
        this.props.redirectToOverview();
      }
    }
  }
  render() {
    if (
      this.props.redirectUserAfterLogIn === true &&
      this.props.redirectUserAfterFollow === true
    ) {
      const userId = this.props.userIdToFollowWithoutLogIn;
      this.props.resetRedirectVars();
      return <Redirect to={`/profile/${userId}`} push />;
    } else if (this.props.redirectToOverviewComp === true) {
      this.props.resetRedirectVars();
      return <Redirect to="/overview" push />;
    }
    return (
      <div className="PROGRESS_SCR">
        <div className="PROGRESS_TITLE">
          <div className="TITLE_2">
            {translate("SUPPORTER_NEWSLETTER_TITLE")}
          </div>
        </div>
        <div
          className="PROGRESS_COMP_1"
          onClick={this.toggleSelect.bind(this, "m")}
        >
          <ProgressComp
            type={translate("SUPPORTER_NEWSLETTER_FREQUENCY_1")}
            isSelected={this.state.progress === "monthly"}
          />
        </div>
        <div
          className="PROGRESS_COMP_2"
          onClick={this.toggleSelect.bind(this, "w")}
        >
          <ProgressComp
            type={translate("SUPPORTER_NEWSLETTER_FREQUENCY_2")}
            isSelected={this.state.progress === "weekly"}
          />
        </div>
        <div
          className="PROGRESS_COMP_3"
          onClick={this.toggleSelect.bind(this, "n")}
        >
          <ProgressComp
            type={translate("SUPPORTER_NEWSLETTER_FREQUENCY_3")}
            isSelected={this.state.progress === "never"}
          />
        </div>
        <div className="NEXTBTN_PRG_AREA">
          <div
            className="NEXTBTN_PRG"
            onClick={this.selectProgressUpdate.bind(this)}
          >
            <CtaButton
              width={"280px"}
              text={translate("CTA_NEXT")}
              color={"white"}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    regError: state.reg.regError,
    progressUpdateCompleted: state.reg.progressUpdateCompleted,
    userStatusToFollow: state.sup.userStatustoFollow,
    userIdToFollowWithoutLogIn: state.sup.userIdToFollowWithoutLogIn,
    userToFollowWithoutLogIn: state.sup.userToFollowWithoutLogIn,
    ownAuth: state.firebase.auth,
    redirectUserAfterLogIn: state.sup.redirectUserAfterLogIn,
    redirectUserAfterFollow: state.sup.redirectUserAfterFollow,
    redirectToOverviewComp: state.sup.redirectToOverviewComp,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setProgressUpdater: (progress) => dispatch(setProgressUpdater(progress)),
    resetProgressVar: () => dispatch(resetProgressVar()),
    followUserAfter: (uid, user) => dispatch(followUserAfter(uid, user)),
    redirectAfterLogin: () => dispatch(redirectAfterLogin()),
    resetRedirectVars: () => dispatch(resetRedirectVars()),
    redirectToOverview: () => dispatch(redirectToOverview()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProgressScr);



// WEBPACK FOOTER //
// ./src/components/Registration/progress.tsx